<template>
  <div class="banner mb-0 mt-5 text-center">
    <div class="px-3 col-12">
      <span class="font-weight-light font-italic text-light">Affordable. Convenient. Respected.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner'
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Banner.vue